(function () {

  'use strict';

  eclipseApp.factory('prepaidRefillAutoPayPlanService', function() {

     var refillValue = {};
     function setRefillValue(data) {
         refillValue = data;
     }

     function getRefillValue() {
         return refillValue;
     }

     return {
      setRefillValue: setRefillValue,
      getRefillValue: getRefillValue,
     };

  });

})();
